<template></template>

<script>
export default {
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.$store.commit("setState", ["user", null]);
      localStorage.removeItem(
        process.env.VUE_APP_PROTOCOL
          ? "m3dHubEditor__token"
          : "kirinote__token"
      );
      // this.$router.replace("/account/login");
      this.$router.replace(
        process.env.VUE_APP_PROTOCOL ? "/account/login" : "/account/login"
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
